// extracted by mini-css-extract-plugin
export default {"manager":"Manager_manager__8Rj6L","fullName":"Manager_fullName__-KZh6"};